module.exports = __webpack_public_path__ + "static/media/ic_add_storage.437e96d2.svg";